import React from 'react';
import {Route, Routes} from 'react-router-dom';
import RecruitCrm from '@/views/creators/recruit-crm';

export const RECRUIT_CRM_ROUTES = {
  MAIN: '',
};

function RecruitCrmRoutes() {
  return (
    <Routes>
      <Route path={RECRUIT_CRM_ROUTES.MAIN} element={<RecruitCrm />} />
    </Routes>
  );
}

export default RecruitCrmRoutes;
